import { contractLaneSectionValidationMap } from './sections/contractLane/validations';

export const cbBankOfferDataFieldValidation = {
  ...contractLaneSectionValidationMap,
};
